<template lang='pug'>
  div.sc-predictive_models
    ods-row.h100(type='flex' justify='center')
      ods-col.h100(
        :xs='24'
        :sm='24'
        :md='24'
      )
        div.viewModel.h100
          //- ods-row(type='flex' justify='space-between')
          //-   p.title Elige el modelo que quieres ejecutar
          ods-row.h100(type='flex')
            div.selectBox
              div.selectBox-item(@click="gotoRoute('PredictiveModelsSports')")
                div.d-flex
                  ods-icon.selectBox-item__icon(name="user-role")
                  ods-icon.selectBox-item__arrow(name="arrow-right")
                div
                  p.selectBox-item__title {{ $t('predictiveModels.instalacionesdeportivas') }}
                  p.selectBox-item__description {{ $t('predictiveModels.sportInstallationsDescription') }}
              div.selectBox-item(@click="gotoRoute('PredictiveModelsPollution')")
                div.d-flex
                  ods-icon.selectBox-item__icon(name="broadcast")
                  ods-icon.selectBox-item__arrow(name="arrow-right")
                div
                  p.selectBox-item__title {{ $t('predictiveModels.contaminaciónenelaire') }}
                  p.selectBox-item__description {{ $t('predictiveModels.pollutionDescription') }}
</template>

<script>
import mapElements from '@/mixins/mapElements'

export default {
  name: 'PredictiveModelsList',
  data () {
    return {
    }
  },
  mixins: [ mapElements ],
  computed: {
  },
  watch: {
  },
  components: {
  },
  methods: {
    gotoRoute (route) {
      this.$router.push({name: route})
    }
  },
  created () {
  }
}
</script>
<style lang='scss' scoped>
  .sc-predictive_models{
    padding: rem(32) rem(24);
    .d-flex {
      display: flex;
    }
    [class*=" ods-icon-"], [class^=ods-icon-]{
      color: $--color-primary;
    }
    .selectBox{
      display: flex;
      &-item{
        max-width: 316px;
        width: 316px;
        padding: 20px;
        background: white;
        margin: 0 8px;
        & > div {
          justify-content: space-between;
        }
        &__icon{
          background: #F9F9FB;
          padding: 20px;
          border-radius: 50%;
        }
        &__title{
          font-size: 16px;
          line-height: 24px;
          color: #060E14;
          margin: 17px 0 0;
          font-weight: 500;
        }
        &__description{
          font-size: 11px;
          line-height: 16px;
          color: #000000;
          margin: 10px 0;
        }
        &__arrow{
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/predictiveModels/PredictiveModelsList.vue